// 编辑页的整体状态
import { defineStore } from 'pinia'
import { loginOut } from '@/api'
import router from '@/baseUtils/router'
import { GuideItrem, Response } from '@/types'
import { getCapacity as ApiGetCapacity, getPoints as APIGetPoints } from '@/api'
import { t } from '@/locales'

export const useUserStore = defineStore('user', () => {
	const loginState = ref(false)
	const points = ref(0)
	const openLoginPop = ref(false)
	const loginNextUrl = ref('/')
	const userName = ref('U-King')
	const nickName = ref('U-King')
	const email = ref('')
	const mobile = ref('')
	const createTime = ref('')
	const hasPassword = ref(false)
	const workWechatId = ref<string | null>(null)
	const guide = ref<GuideItrem[]>([])
	const capacityTotal = ref('0')
	const capacityLimit = ref('0')
	const setLoginState = (state: boolean) => {
		loginState.value = state
	}

	const setPoints = (point: number) => {
		points.value = point
	}

	const setGuide = (list: GuideItrem[]) => {
		guide.value = list
	}

	// 单独设置guide一个值
	const setGuideItemState = (type: string, state: boolean) => {
		guide.value.forEach(item => {
			if (item.type === type) {
				item.need = state
			}
		})
	}

	const getGuide = () => {
		return readonly(guide.value)
	}

	const setOpenLoginPop = (state: boolean) => {
		openLoginPop.value = state
	}

	const setLoginNextUrl = (url: string) => {
		loginNextUrl.value = url
	}

	const getLoginNextUrl = () => {
		return loginNextUrl.value
	}
	// 更新积分
	const updatePoints = async () => {
		try {
			const res = await APIGetPoints()
			points.value = res.data[0] || 0
		} catch (err) {
			console.log(err)
		}
	}

	// 验证积分
	const checkPoints = async (num: number) => {
		try {
			await updatePoints()
			if (points.value < num) {
				ElMessage.error(t('common.checkPointsError'))
				return false
			}
			return true
		} catch (err) {
			console.log(err)
		}
	}

	// 清除用户信息（不重定向不刷新页面）
	const clearUserInfo = () => {
		loginState.value = false
		points.value = 0
		localStorage.removeItem('nickName')
		localStorage.removeItem('userId')
		localStorage.removeItem('loginState')
		localStorage.removeItem('userInfo')
		localStorage.removeItem('userHash')
		localStorage.removeItem('update-tips-shown')
	}

	// 退出登录
	const logout = async () => {
		await loginOut()
		clearUserInfo()
		await router.replace({ path: '/' })
		location.reload()
	}

	// 登录成功
	const loginSuccess = async (data: any) => {
		localStorage.setItem('userId', data.userId)
		localStorage.setItem('nickName', data.nickName)
		localStorage.setItem('loginState', '1')
		nickName.value = data.nickName
		loginState.value = true
	}

	function init() {
		if (localStorage.getItem('loginState') === '1') {
			loginState.value = true
		} else {
			loginState.value = false
		}
		nickName.value = localStorage.getItem('nickName') || 'U-King'
	}

	// 获取容量
	const getCapacity = async () => {
		const res: Response<any> = await ApiGetCapacity()
		capacityTotal.value = res.data[0].total
		capacityLimit.value = res.data[0].limit
	}

	init()

	return {
		loginState,
		points,
		logout,
		clearUserInfo,
		setOpenLoginPop,
		openLoginPop,
		setLoginNextUrl,
		getLoginNextUrl,
		userName,
		loginSuccess,
		setGuide,
		getGuide,
		guide,
		setGuideItemState,
		getCapacity,
		capacityLimit,
		capacityTotal,
		nickName,
		email,
		mobile,
		createTime,
		hasPassword,
		workWechatId,
		updatePoints,
		checkPoints
	}
})
